import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { OneTimePasscodeStatus } from '@interfaces/one-time-passcode/otp.interface';
import { Store } from '@ngrx/store';
import { OtpVerificationModalContent } from '@shared/services/content/content-jsons/otp-verification-modal-content';
import { Next, ProcessSideStepData, TrackProcessSideStep } from '@store/actions';
import { UpdateOTPVerification } from '@store/actions/otp/otp.actions';
import { ButtonComponent, ButtonModule } from '@vg-constellation/angular-16/button';
import { ModalDialogComponent, ModalDialogModule } from '@vg-constellation/angular-16/modal-dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-otp-verification-modal',
  templateUrl: './otp-verification-modal.component.html',
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent, ModalDialogModule, ButtonModule],
})
export class OtpVerificationModalComponent implements OnInit, OnDestroy {
  public content = OtpVerificationModalContent;

  subscription: Subscription | null = null;
  adobeData: ProcessSideStepData | null = null;
  @Input() openOTPDialog: EventEmitter<void> | null = null;

  @ViewChild('otpVerificationModal') otpVerificationModal: ModalDialogComponent | undefined;

  constructor(private store: Store) {}

  ngOnInit(): void {
    if (this.openOTPDialog) {
      this.subscription = this.openOTPDialog?.subscribe((adobeData) => {
        this.otpVerificationModal?.openModalDialog();
      });
    }
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public closeModal() {
    this.otpVerificationModal?.closeDialogModal();
  }

  public confirm(): void {
    this.store.dispatch(UpdateOTPVerification({ payload: OneTimePasscodeStatus.YES }));
    this.closeModal();
  }

  public notApplicable(): void {
    this.store.dispatch(UpdateOTPVerification({ payload: OneTimePasscodeStatus.NOT_APPLICABLE }));
    this.closeModal();
  }
}
